import _ from "lodash";

export const hasStructuredContact = (user) => {
  if (!user) return false;
  return !!( _.trim(user.wechat_id) || _.trim(user.contact_email) );
};

export const hasContactInfo = (user) => {
  if (!user) return false;
  if (_.trim(user.wechat_id)) return true;
  if (hasStructuredContact(user)) return true;
  return !!_.trim(user.contact_info);
};

export const isContactRevealed = (user) => {
  if (!user) return false;
  return (
    _.has(user, "wechat_id") ||
    _.has(user, "contact_email") ||
    _.has(user, "contact_info")
  );
};

export const hasAnyRole = (user, roles) => {
  return user && _.intersection(user.roles, roles).length > 0;
};

const GENDER_LABELS = {
  male: "男",
  female: "女",
  other: "其他",
};

export const formatGender = (gender) => GENDER_LABELS[gender] || null;
